import React from 'react';
import './Footer.css';

const Footer = () => (
  <footer className="footer-with-video">
    <video
      className="footer-bg-video"
      src="/videos/v3.mp4"
      autoPlay
      loop
      muted
      playsInline
    />
    <div className="footer-inner">
      <div className="container footer">
        {/* PRODUCTS */}
        <div className="footer-blocks">
          <h3 className="footer-blocks-header">Products</h3>
          <ul className="footer-linkss">
            <li>
              <a href="https://trezi.com" target="_blank" rel="noreferrer">
                Trezi
              </a>
            </li>
          </ul>
        </div>

         {/* COMPANY */}
        <div className="footer-blocks">
          <h3 className="footer-blocks-header">Company</h3>
          <ul className="footer-linkss">
            <li><a href="/about">About</a></li>
            <li><a href="/career">Careers</a></li>
             <li><a href="/press">Press</a></li>
            {/* <li><a href="/terms">Terms</a></li> */}
            <li><a href="/privacy">Privacy</a></li>
          </ul>
        </div>

        {/* SOCIAL LINKS */}
        <div className="footer-blocks">
          <h3 className="footer-blocks-header">Get in touch</h3>
          <ul className="footer-links social-links">
            {[
              { href: 'https://www.linkedin.com/company/smartvizs-pvt-ltd-/', icon: 'linkedin', title: 'Linkedin' },
              { href: 'https://www.facebook.com/smartvizx/', icon: 'facebook', title: 'Facebook' },
              { href: 'https://twitter.com/ByTrezi', icon: 'twitter', title: 'Twitter' },
              { href: 'https://www.instagram.com/smartvizx/', icon: 'instagram', title: 'Instagram' },
              { href: 'https://www.youtube.com/channel/UCnAGo5MdsIyM9UIDn7_ouOg', icon: 'youtube', title: 'Youtube' },
            ].map(({ href, icon, title }) => (
              <li key={icon}>
                <a href={href} target="_blank" rel="noreferrer">
                  <img className="logo" src={`/img/svg/${icon}.svg`} alt={title} />
                  <span className="title">{title}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="container text-center">
        <p>SMARTVIZX © 2025</p>
      </div>
    </div>
  </footer>
);

export default Footer;
